import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import { PRIVATE_ROUTES } from '../../routes'
import ReportingHubPage from './ReportingHubPage'
import ReportingProjectCapacityPage from './ReportingProjectCapacityPage'
import ReportingWorkloadPage from './ReportingWorkloadPage'
import SavedReportsPage from './workload/SavedReportsPage'
import SavedReportDetailPage from './workload/SavedReportDetailPage'

const ReportingRouter = () => (
    <Routes>
        <Route index element={<ReportingHubPage />} />
        <Route path="workload/saved/:reportId" element={<SavedReportDetailPage />} />
        <Route path="workload/saved" element={<SavedReportsPage />} />
        <Route path="workload" element={<ReportingWorkloadPage />} />
        <Route
            path="project-capacity"
            element={<ReportingProjectCapacityPage />}
        />
        <Route
            path="*"
            element={<Navigate to={PRIVATE_ROUTES.reporting} replace />}
        />
    </Routes>
)

export default ReportingRouter
